import apiAccess from '../../api/apiAccess'

// access_code 到前端路由配置的映射表
// 后台新增菜单项时，只需在这里添加对应的映射
const MENU_ITEM_MAP = {
  1000003: { id: 'dashboard', icon: 'mdi-view-dashboard', name: 'title.dashboard' },
  1000004: { id: 'realTimeMonitor', icon: 'mdi-map-marker-radius', name: 'home.realTimeMonitor' },
  1000005: { id: 'trackPlayback', icon: 'mdi-map-marker-path', name: 'home.trackPlayback', svg: 'trackplayback', isSvg: true },
  1000006: { id: 'statisticalReport', icon: 'mdi-chart-bar', name: 'home.statisticalReport' },
  1000010: { id: 'geoFence', icon: 'mdi-fence', name: 'title.geoFence' },
  1000013: { id: 'videoMonitor', icon: 'mdi-google-lens', name: 'title.videoMonitor', svg: 'videomonitor', isSvg: true },
  1000014: { id: 'videoPlayback', icon: 'mdi-movie-play-outline', name: 'title.videoPlayback', svg: 'videoplayback', isSvg: true },
  1000701: { id: 'accountManage', icon: 'mdi-account', name: 'title.accountManage' },
  1000702: { id: 'infoManagement', icon: 'mdi-information', name: 'title.infoManagement' },
  1000703: { id: 'vehicleSetting', icon: 'mdi-car', name: 'title.vehicleSetting' },
  1000704: { id: 'driverManagement', icon: 'mdi-card-account-details', name: 'title.driverManagement' },
  1000705: { id: 'poiManagement', icon: 'mdi-map-marker', name: 'title.pOIManagement' },
  1000706: { id: 'otaManage', icon: 'mdi-arrow-up-bold-circle', name: 'title.otaManage' },
  1000707: { id: 'ruleManagement', icon: 'mdi-factory', name: 'title.ruleManagement' },
  1000901: { id: 'maintenanceManage', icon: 'mdi-car-wrench', name: 'title.maintenanceManage' },
  1000902: { id: 'bigtest', icon: 'mdi-monitor-dashboard', name: 'title.bigtest' },
  1000903: { id: 'insuranceManage', icon: 'mdi-shield-car', name: 'title.insuranceManage' },
  1000904: { id: 'certificateManage', icon: 'mdi-certificate', name: 'title.certificateManage' },
}

// 从 definitions 树中提取可导航的菜单项（access_code < 3000000）
function extractMenuItems(items, result = []) {
  if (!items || !Array.isArray(items)) return result

  items.forEach((item) => {
    // 只处理 access_code < 3000000 的菜单项，且 platforms 包含 'web'
    if (
      item.access_code &&
      item.access_code < 3000000 &&
      item.platforms &&
      item.platforms.includes('web')
    ) {
      // 检查是否有对应的前端路由映射
      const mapping = MENU_ITEM_MAP[item.access_code]
      if (mapping) {
        result.push({
          access_code: item.access_code,
          id: mapping.id,
          name: mapping.name,
          icon: mapping.icon,
          svg: mapping.svg,
          isSvg: mapping.isSvg || false,
          // 后台提供的信息
          backendName: item.name,
          localizedName: item.localizedName,
          i18n_key: item.i18n_key,
          default_enabled: item.default_enabled,
        })
      }
    }

    // 递归处理子项
    if (item.children && Array.isArray(item.children)) {
      extractMenuItems(item.children, result)
    }
  })

  return result
}

const permission = {
  namespaced: true,
  state: {
    routes: [],
    addRoutes: [],
    sidebarRouters: [],
    // V2 权限：禁用的权限 access_code 列表（用数组存储，便于 Vuex 持久化）
    disabledPermissions: [],
    // V2 菜单定义：从后台 definitions 提取的可导航菜单项列表
    menuDefinitions: [],
    // 菜单加载状态：登录后先为 true，V2 权限加载完成后才为 false
    menuLoading: true,
    // 命令权限 - 默认都开启，只有查询到且为 false 才关闭
    canSendCommand: true, // 发送命令权限 (3000001)
    canConfigParam: true, // 配置参数权限 (3000002)
    canIntercom: true, // 对讲功能权限 (3000003)
    canQueryLog: true, // 日志查询权限 (3000004) - 关联 Log Search 功能
    // 功能权限 - 使用菜单权限码控制按钮显示
    canTrackPlayback: true, // 轨迹回放权限 (1000005)
    canStatisticalReport: true, // 统计报表权限 (1000006)
    canVideoMonitor: true, // 实时视频权限 (1000013)
    canVideoPlayback: true, // 录像回放权限 (1000014)
    permissionLoaded: false, // 标记权限是否已加载
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = constantRoutes.concat(routes)
    },
    SET_SIDEBAR_ROUTERS: (state, routers) => {
      state.sidebarRouters = constantRoutes.concat(routers)
    },
    // 设置禁用权限列表
    SET_DISABLED_PERMISSIONS: (state, disabledList) => {
      state.disabledPermissions = disabledList
    },
    // 设置菜单定义列表（从后台 definitions 提取）
    SET_MENU_DEFINITIONS: (state, menuDefinitions) => {
      state.menuDefinitions = menuDefinitions
    },
    SET_COMMAND_PERMISSION: (state, permissions) => {
      state.canSendCommand = permissions.canSendCommand
      state.canConfigParam = permissions.canConfigParam
      state.canIntercom = permissions.canIntercom
      state.canQueryLog = permissions.canQueryLog
      state.canTrackPlayback = permissions.canTrackPlayback
      state.canStatisticalReport = permissions.canStatisticalReport
      state.canVideoMonitor = permissions.canVideoMonitor
      state.canVideoPlayback = permissions.canVideoPlayback
      state.permissionLoaded = true
      state.menuLoading = false // V2 权限加载完成，菜单可以显示了
    },
    RESET_COMMAND_PERMISSION: (state) => {
      state.disabledPermissions = []
      state.menuDefinitions = []
      state.menuLoading = true // 重置时设为 loading 状态
      state.canSendCommand = true
      state.canConfigParam = true
      state.canIntercom = true
      state.canQueryLog = true
      state.canTrackPlayback = true
      state.canStatisticalReport = true
      state.canVideoMonitor = true
      state.canVideoPlayback = true
      state.permissionLoaded = false
    },
  },
  actions: {
    // 生成路由
    GenerateRoutes({ commit }) {},

    // 获取命令权限（带缓存，避免重复请求）- V2版本
    async LoadCommandPermission({ commit, dispatch, state }, { force = false } = {}) {
      // 如果已加载且不是强制刷新，直接返回
      if (state.permissionLoaded && !force) {
        return
      }

      // 强制刷新时先重置权限状态
      if (force) {
        commit('RESET_COMMAND_PERMISSION')
      }

      try {
        const sssid = localStorage.getItem('sssid')
        if (!sssid) {
          // 没有 sssid，使用默认权限（开启）
          commit('SET_DISABLED_PERMISSIONS', [])
          commit('SET_COMMAND_PERMISSION', {
            canSendCommand: true,
            canConfigParam: true,
            canIntercom: true,
            canQueryLog: true,
            canTrackPlayback: true,
            canStatisticalReport: true,
            canVideoMonitor: true,
            canVideoPlayback: true,
          })
          return
        }

        // V2 API: GetModelV2 替代原 GetAllModel
        const res = await apiAccess.GetModelV2({
          sChildAccount: sssid,
          platform: 'web',
          lang: localStorage.getItem('language') || 'en',
        })

        // 兼容 res.data 和 res.value
        const data = res.data || res.value
        if (res.state && data) {
          // V2 logic: permissions array contains disabled items
          // If access_code is in permissions → disabled
          // If access_code is NOT in permissions → enabled (default)
          const disabledList = []
          if (data.permissions && Array.isArray(data.permissions)) {
            data.permissions.forEach((p) => {
              disabledList.push(p.access_code)
            })
          }

          // 保存禁用权限列表到 store（供其他组件使用）
          commit('SET_DISABLED_PERMISSIONS', disabledList)

          // 从 definitions 提取可导航的菜单项
          if (data.definitions && data.definitions.items) {
            const menuDefinitions = extractMenuItems(data.definitions.items)
            commit('SET_MENU_DEFINITIONS', menuDefinitions)
            // 同步到 tagsView 的 menuTagList
            dispatch('tagsView/syncMenuFromDefinitions', null, { root: true })
          }

          const disabledPermissions = new Set(disabledList)

          // Check command permissions (3000xxx)
          // 3000001: send command, 3000002: config param
          // 3000003: intercom, 3000004: query log
          const canSendCommand = !disabledPermissions.has(3000001)
          const canConfigParam = !disabledPermissions.has(3000002)
          const canIntercom = !disabledPermissions.has(3000003)
          const canQueryLog = !disabledPermissions.has(3000004)

          // Check feature permissions (1000xxx - 菜单权限码)
          // 1000005: track playback, 1000006: statistical report
          // 1000013: video monitor, 1000014: video playback
          const canTrackPlayback = !disabledPermissions.has(1000005)
          const canStatisticalReport = !disabledPermissions.has(1000006)
          const canVideoMonitor = !disabledPermissions.has(1000013)
          const canVideoPlayback = !disabledPermissions.has(1000014)

          commit('SET_COMMAND_PERMISSION', {
            canSendCommand,
            canConfigParam,
            canIntercom,
            canQueryLog,
            canTrackPlayback,
            canStatisticalReport,
            canVideoMonitor,
            canVideoPlayback,
          })
        } else {
          // 查询失败，使用默认权限（开启）
          commit('SET_DISABLED_PERMISSIONS', [])
          commit('SET_COMMAND_PERMISSION', {
            canSendCommand: true,
            canConfigParam: true,
            canIntercom: true,
            canQueryLog: true,
            canTrackPlayback: true,
            canStatisticalReport: true,
            canVideoMonitor: true,
            canVideoPlayback: true,
          })
        }
      } catch (error) {
        console.error('获取命令权限失败:', error)
        // 出错时使用默认权限（开启）
        commit('SET_DISABLED_PERMISSIONS', [])
        commit('SET_COMMAND_PERMISSION', {
          canSendCommand: true,
          canConfigParam: true,
          canIntercom: true,
          canQueryLog: true,
          canTrackPlayback: true,
          canStatisticalReport: true,
          canVideoMonitor: true,
          canVideoPlayback: true,
        })
      }
    },

    // 强制刷新命令权限（登录后或权限变更时使用）
    async ForceLoadCommandPermission({ dispatch }) {
      return dispatch('LoadCommandPermission', { force: true })
    },
  },
}

export default permission
